import { useCallback, useState } from "react";
import { useUIDSeed } from "react-uid";
import styled from "@emotion/styled";
import PropTypes from "prop-types";

import {
    InfiniteLoadTrigger,
    useDebounce,
    useDrawer,
    useListElastic,
    useSearchAnalytics,
} from "@hmn/coolinarika-web-core/hooks";

import { withErrorBoundary } from "../../ErrorBoundary";
import { TextField } from "../../Input/components/TextField";
import DishListing from "../Listing/Listing.component";
import { DishListingElement } from "../ListingElement";
import styles from "./Drawer.style";

const DishDrawerStyled = styled.div((props) => ({ ...styles(props) }));

const DishDrawerAll = ({ className, ...props }) => {
    const uid = useUIDSeed();
    const [searchTerm, setSearchTerm] = useState();
    const debouncedSearch = useDebounce(searchTerm, 500);

    const { pages, ref, isFetching } = useListElastic({
        resource: "jela/1st-level",
        params: {
            query: {
                search: debouncedSearch,
            },
        },
    });

    const { open: openSingleDrawer } = useDrawer("dish-drawer-single");

    useSearchAnalytics("Dishes search", isFetching, searchTerm, pages);

    const handleElementClick = useCallback((item) => {
        openSingleDrawer({
            stickyDish: {
                imageId: item?.image?.id,
            },
            contentId: item?.id,
            title: item?.title,
            slug: item?.slug,
            content: item,
            gtmData: {
                action: "Pogledaj sva jela",
                label: "Jela u sezoni",
            },
        });
    }, []);

    const handleSearch = (event) => {
        setSearchTerm(event?.target?.value?.trim()?.toLowerCase());
    };

    return (
        <DishDrawerStyled className={className} {...props}>
            <TextField
                className="dishDrawerInput"
                placeholder="Pretraži jela"
                onChange={handleSearch}
            />
            <DishListing className="dishDrawerListing">
                {!!pages?.length &&
                    !!pages?.[0]?.length &&
                    pages?.map((foodTypePage, pageIndex) =>
                        foodTypePage.map((item, index) => (
                            <DishListingElement
                                key={uid(item?.id || `${pageIndex}-${index}`)}
                                imageId={item?.image?.id}
                                title={item?.title}
                                onElementClick={() => handleElementClick(item)}
                            />
                        )),
                    )}
            </DishListing>
            <InfiniteLoadTrigger ref={ref} />
        </DishDrawerStyled>
    );
};

DishDrawerAll.propTypes = {
    ssrData: PropTypes.arrayOf(PropTypes.shape({})),
    className: PropTypes.string,
};

DishDrawerAll.defaultProps = {
    ssrData: [],
    className: undefined,
};

export default withErrorBoundary(DishDrawerAll);
